import { createContext, useContext } from 'react';

/** How BodyWithAside is laying out its modules right now. */
export type AsideLayout = 'column' | 'strip' | 'stack';

// Outside a BodyWithAside a module renders its full shape.
export const AsideLayoutContext = createContext<AsideLayout>('column');

export function useAsideLayout(): AsideLayout {
  return useContext(AsideLayoutContext);
}
